export default __webpack_public_path__ + "static/media/QSGRW_PC_Classified.a8798547.png";